import React from 'react';
import { Link } from 'react-router-dom';
import { getImageUrl } from '../api';
import { productSlug } from '../utils/slug';
import { useWishlist } from '../context/WishlistContext';
import { useAuth } from '../context/AuthContext';

export default function ProductCard({ product }) {
  const thumbnail = product.images && product.images.length > 0
    ? product.images[0].image_url
    : product.image_url;
  const imgUrl = getImageUrl(thumbnail);
  const { toggle, isSaved } = useWishlist();
  const { user } = useAuth();
  const saved = isSaved(product.id);

  return (
    <div style={{ position: 'relative' }}>
      <Link to={`/product/${productSlug(product.name, product.id)}`} className="product-card" style={{ textDecoration: 'none', color: 'inherit' }}>
        <div style={{ position: 'relative' }}>
          {imgUrl ? (
            <img src={imgUrl} alt={product.name} className="product-card-img" />
          ) : (
            <div className="product-card-placeholder">&#128230;</div>
          )}
          {/* VIP Only badge */}
          {product.vip_only ? (
            <div style={{ position:'absolute', top:8, left:8, background:'linear-gradient(135deg,#4f46e5,#7c3aed)', color:'white', fontSize:11, fontWeight:800, padding:'3px 10px', borderRadius:100, letterSpacing:0.5, zIndex:2 }}>
              💎 VIP Only
            </div>
          ) : null}
        </div>
        <div className="product-card-body">
          <div className="product-card-title">{product.name}</div>
          {product.brand && <div className="product-card-brand">{product.brand}</div>}
          {product.avg_rating > 0 && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 4, margin: '4px 0' }}>
              <span style={{ color: '#f59e0b', fontSize: 13 }}>{'★'.repeat(Math.round(product.avg_rating))}{'☆'.repeat(5 - Math.round(product.avg_rating))}</span>
              <span style={{ fontSize: 12, color: '#6b7280' }}>({product.review_count})</span>
            </div>
          )}
          <div className="product-card-price">
            <span className="currency">$</span>{product.price.toFixed(2)}
          </div>
        </div>
      </Link>
      {user && (
        <button onClick={e => { e.stopPropagation(); toggle(product.id); }}
          style={{ position:'absolute', top:8, right:8, background: saved?'#ef4444':'rgba(255,255,255,0.9)', border:'none', borderRadius:'50%', width:32, height:32, cursor:'pointer', fontSize:17, display:'flex', alignItems:'center', justifyContent:'center', boxShadow:'0 1px 4px rgba(0,0,0,0.15)', zIndex:2, color: saved?'white':'#374151' }}
          title={saved ? 'Remove from wishlist' : 'Save to wishlist'}>
          {saved ? '\u2665' : '\u2661'}
        </button>
      )}
    </div>
  );
}
